import { formatCitationRefLabel, getCitationKind } from '@/lib/message';
import { MessageContext } from '@/contexts/MessageContext';
import MaterialIcon from '@/components/MaterialIcon';
import { useContext } from 'react';
import { useTranslation } from 'components/i18n/Translator';

import type { IMessageElement } from '@chainlit/react-client';

interface ElementRefProps {
  element: IMessageElement;
}

const ElementRef = ({ element }: ElementRefProps) => {
  const { onElementRefClick } = useContext(MessageContext);
  const { i18n } = useTranslation();
  const label = formatCitationRefLabel(element.name, i18n.language);
  const citationKind = getCitationKind(element.name);
  const citationIcon = citationKind
    ? { memory: 'memory', document: 'description', web: 'web_source' }[
        citationKind
      ]
    : undefined;
  const safeElement =
    citationKind === 'memory'
      ? {
          ...element,
          content:
            i18n.language?.toLowerCase().startsWith('en')
              ? 'This answer used your private previous conversations.'
              : 'Ovaj odgovor koristi tvoje privatne prethodne razgovore.',
          url: `data:text/plain;charset=utf-8,${encodeURIComponent(
            i18n.language?.toLowerCase().startsWith('en')
              ? 'This answer used your private previous conversations.'
              : 'Ovaj odgovor koristi tvoje privatne prethodne razgovore.'
          )}`
        }
      : element;

  // For inline elements, return a styled span
  if (element.display === 'inline') {
    return <span className="font-bold">{label}</span>;
  }

  // For other elements, return a clickable link
  return (
    <a
      href="#"
      className="fongpt-hover cursor-pointer -translate-y-px inline-flex h-7 w-7 items-center justify-center rounded-lg bg-muted text-secondary element-link"
      onClick={() => onElementRefClick?.(safeElement)}
      aria-label={label}
      title={label}
    >
      {citationIcon ? (
        <MaterialIcon name={citationIcon} size={16} className="shrink-0" />
      ) : (
        label
      )}
    </a>
  );
};

export { ElementRef };
